import type { TFunction } from 'i18next';
import { z } from 'zod';

import type { TaskOutcome } from '@/services/ws-funnel/src/main/resources/rest-api';
import { optionSchema } from '@/js/libs/form';

export const createSchema = (t: TFunction) =>
  z.object({
    outcome: optionSchema(z.custom<TaskOutcome>())
      .nullable()
      .refine(Boolean, { message: t('messages:FIELD_IS_REQUIRED') }),
  });

export type FormValues = z.infer<ReturnType<typeof createSchema>>;
